const numberListTableStyle = () => ({
	tableContainer: {
		margin: '0 16px',
		width: 'auto',
	},
	tableStyle: {
		borderCollapse: 'separate',
		borderSpacing: '0 10px',
		'&:last-child': {
			padding: '0px',
		},
	},
	tableHeadStyle: {
		display: 'none',
	},
	tableRowStyle: {
		borderRadius: 8,
		border: '2px solid',
	},
	tableCellStyle: {
		'white-space': 'nowrap',
		border: 'hidden',
		backgroundColor: '#fff',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		cursor: 'pointer',
		'&:first-child': {
			display: 'flex',
			'padding-right': '0px',
			borderTopLeftRadius: 8,
			borderBottomLeftRadius: 8,
		},
		'&:nth-child(2)': {
			'max-width': '110px',
			overflow: 'hidden',
			'text-overflow': 'ellipsis',
			'& p': {
				'text-overflow': 'ellipsis',
				overflow: 'hidden',
			},
		},
		'&:last-child': {
			'max-width': '100px',
			'padding-left': '0',
			overflow: 'hidden',
			'text-overflow': 'ellipsis',
			'white-space': 'nowrap',
			borderTopRightRadius: 8,
			borderBottomRightRadius: 8,
			'& p': {
				'text-overflow': 'ellipsis',
				overflow: 'hidden',
			},
		},
	},
	phoneIcon: {
		display: 'flex',
		margin: 'auto 0',
		marginRight: '4px',
		transform: 'scaleX(-1)',
		fill: '#2093cf',
		fontSize: '1rem',
	},
	searchWrapper: {
		margin: '12px 8px auto 8px',
		'& :first-child': {
			'min-height': 0,
		},
		'& div': {
			borderRadius: 8,
			backgroundColor: 'transparent',
			border: 'none',
		},
		'& svg': {
			width: 'auto',
			height: '1em',
		},
		'& .MuiInputLabel-root': {
			top: '-19px',
			transition: 'none',
		},
		'& .MuiInputLabel-shrink': {
			clip: 'rect(0 0 0 0)',
		},
		'& .MuiFormControl-root': {
			'margin-bottom': '2px',
			padding: 0,
		},
	},
	svgContainer: {
		display: 'flex',
		'align-items': 'center',
		height: '100%',
	},
	textWrapper: {
		margin: '0 16px',
		display: 'flex',
		'align-items': 'center',
	},
	bolded: {
		fontWeight: 'bold',
	},
	searchIcon: {
		display: 'flex',
		margin: '0 0 0 auto',
	},
});

export default numberListTableStyle;
